<template>
    <div class="page magic-bg dark:text-white">
        <navigation :key="navigationKey"/>
        <div class="bookmark">
            <div class="bookmark-container">
                <div class="bookmark-modal" id="user_list_adjustments">
                    <div class="flex flex-row items-center justify-between mb-2">
                        <p class="bookmark-modal-title text-gradient mr-auto">Сортировка</p>
                        <button class="rounded-button" title="Очистить сортировку" @click="ClearParams">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 hover:animate-spin" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28">Поиск</label>
                        <input class="input sm:ml-2" type="text" v-model="search_param">
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28 break-words">Статус</label>
                        <select class="input sm:ml-2" v-model="status_param">
                            <option value="">Все</option>
                            <option value="false">Открыт</option>
                            <option value="true">Закрыт</option>
                        </select>
                    </div>
                    <p class="bookmark-modal-title text-gradient mr-auto">Инструменты</p>
                    <button class="mt-2 ml-2 mr-auto" @click="_ProccessRecords()">Запросить данные заново</button>
                </div>
            </div>
            <div class="bookmark-navbar">
                <div class="bookmark-link" @click="$root.ToggleBookmark('#user_list_adjustments')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z" />
                    </svg>
                </div>
            </div>
        </div>
        <div class="card py-0 w-[90%] max-w-5xl mt-4 mx-auto overflow-auto fade" style="max-height: calc(100vh - 10rem)">
            <table class="sys-table mb-2">
                <thead>
                    <th>№</th>
                    <th>ФИО</th>
                    <th>Email</th>
                    <th>Номер телефона</th>
                    <th>Курс</th>
                    <th>Дата записи</th>
                </thead>
                <tbody>
                    <tr v-for="(record, index) in records" :key="index">
                        <th>{{index + 1}}</th>
                        <td class="text-center">{{record.FIO}}</td>
                        <td class="text-center">{{record.Email}}</td>
                        <td class="text-center">{{record.Phone}}</td>
                        <td class="text-left">{{record.Course.Title}}</td>
                        <td class="text-center">{{record.Date.toLocaleString("ru-RU", { day: "2-digit", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" })}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import Navigation from '@/components/Navigation'
import FileInput from '@/components/FileInput'

export default {
    components: {
        Navigation,
        FileInput
    },
    data() {
        return {
            search_param: "",
            status_param: "",
            course_types: [],
            records: [],
            navigationKey: "nav",
            title: "Записи на курсы"
        }
    },
    methods: {
        SetTitle() {
            document.title = `Samgk DPO - ${this.title}`
        },
        ClearParams() {
            this.search_param = ""
            this.status_param = ""
        },
        async _SelectData() {
            let res = await fetch(this.$store.state.aeApiAddr + "/v1.0/courses/types", {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            this.course_types = res.data.types
        },
        async _ProccessRecords() {
            this.$root.StartLoading()

            var res = await fetch(this.$store.state.aeApiAddr + `/v1.0/courses/list?search=${this.search_param}&is_closed=${this.status_param}`, {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            if (this.$root.HandleFetchError(res)) return

            let records = []

            for (var i in res.data.courses) {
                const course = res.data.courses[i]

                for (var j in course.participants) {
                    const participant = course.participants[j]

                    records.push({
                        FIO: `${ participant.surname } ${ participant.name } ${ participant.middle_name }`.trim().replaceAll("  ", " "),
                        Email: participant.email,
                        Phone: participant.number_phone,
                        Date: new Date(participant.meta.date_created),
                        Course: {
                            ID: course.id,
                            Title: course.title,
                            Type: course.type,
                            Description: course.description,
                            VolumeHours: course.volume_of_hours,
                            Price: course.price,
                            StudentPrice: course.price_for_students ?? "",
                            Closed: course.is_closed ?? false,
                        },
                    })
                }
            }

            records.sort((a , b) => a.Date > b.Date ? -1 : 1)

            this.records = records

            this.$root.EndLoading()
        },
    },
    mounted() {
        if (this.$root.fatal) return
        this.SetTitle()
        this.$root.StartLoading()
        this.$root.UpdateToken()
        this.$root.GetRoles().then(()=>{
            if (!(this.$root.HasRole(this.$store.state.adminRole) || this.$root.HasRole(this.$store.state.methodistRole))) {
                this.$root.ShowToast("У вас нет прав на посещение данного раздела", "error", 8000)
                this.$router.push({name: 'Home'})
                return
            }
            this._ProccessRecords().then(()=>{
                this.$root.EndLoading()
            })
            this._SelectData()
        })   
    }
}
</script>